import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';

const AddShopModule = Loadable(
	lazy(() => import('modules/Shop/pages/AddShopModule')),
);

const ShopModulesList = Loadable(
	lazy(() => import('modules/Shop/pages/ShopModulesList')),
);

const UpdateShopModule = Loadable(
	lazy(() => import('modules/Shop/pages/UpdateShopModule')),
);

const SHOP_ROUTES: IRoute[] = [
	{
		path: '/shop/modules',
		element: ShopModulesList,
		name: 'ShopModulesList',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'shop/modules/add',
		element: AddShopModule,
		name: 'AddShopModule',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: 'shop/modules/update/:moduleId',
		element: UpdateShopModule,
		name: 'UpdateShopModule',
		roles: [ROLES.ADMIN],
		private: true,
	},
	// {
	// 	path: 'culture-card/categories',
	// 	element: CategoriesList,
	// 	name: 'CategoriesList',
	// 	roles: [ROLES.ADMIN],
	// 	private: true,
	// },
	// {
	// 	path: 'culture-card/cards',
	// 	element: CardsList,
	// 	name: 'CardsList',
	// 	roles: [ROLES.ADMIN],
	// 	private: true,
	// },

	// {
	// 	path: 'culture-card/cards/update/:cardId',
	// 	element: UpdateCard,
	// 	name: 'UpdateCard',
	// 	roles: [ROLES.ADMIN],
	// 	private: true,
	// },
];

export default SHOP_ROUTES;
